// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("default/js/" + chunkId + ".js?id=" + {"3872":"72de86ed6729ee6e96a9","6901":"387da7057d1e195c3dd7"}[chunkId] + "");